import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { CLIENTS_ENDPOINTS } from 'src/app/core/api/endpoints/clients.endpoints';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  private api = inject(ApiService);

  getClientByPage(query): Observable<any> {
    return this.api.get(CLIENTS_ENDPOINTS.V1.CLIENTS, { params: query });
  }

  deleteClients(clientId): Observable<any> {
    return this.api.delete(CLIENTS_ENDPOINTS.V1.CLIENT_DETAIL(clientId));
  }

  updateClientById(id, client) {
    return this.api.put<any>(CLIENTS_ENDPOINTS.V1.CLIENT_DETAIL(id), client);
  }

  getClientByID(id): Observable<any> {
    return this.api.get(CLIENTS_ENDPOINTS.V1.CLIENT_DETAIL(id));
  }

  addClients(client): Observable<any> {
    return this.api.post(CLIENTS_ENDPOINTS.V1.USER, client);
  }

  getAllClients(params): Observable<any> {
    return this.api.get(CLIENTS_ENDPOINTS.V1.ALL_CLIENTS,  {params: params});
  }

  getCustomersRating(query): Observable<any> {
    return this.api.get(CLIENTS_ENDPOINTS.V1.CUSTOMER_RATINGS, { params: query });
  }

  getFinalStatus(): Observable<any> {
    return this.api.get(CLIENTS_ENDPOINTS.V1.FINAL_STATUS);
  }

  updateClientRateById(id, clientRate) {
    return this.api.put<any>(CLIENTS_ENDPOINTS.V1.CUSTOMER_RATING_DETAIL(id), clientRate);
  }

  getAllCustomerRating(query) {
    return this.api.get(CLIENTS_ENDPOINTS.V1.ALL_CUSTOMER_RATINGS, { params: query });
  }
}
